export const SUPPORTED_GOOGLE_FONTS = [
  'Dancing Script',
  'Lato',
  'Lobster',
  'Lobster Two',
  'Lora',
  'Montserrat',
  'Montserrat Alternates',
  'Nunito',
  'Nunito Sans',
  'Open Sans',
  'Open Sans Condensed',
  'PT Sans',
  'PT Serif',
  'Raleway',
  'Roboto',
  'Roboto Condensed',
  'Roboto Mono',
  'Roboto Slab',
  'Alegreya',
  'Alegreya Sans',
  'Merriweather',
  'Merriweather Sans',
  'Quattrocento',
  'Quattrocento Sans',
  'Arvo',
  'Copse',
  'Cutive',
  'Sanchez',
  'Scope One',
  'Slabo 27px',
  'Trocchi',
  'Vesper Libre',
  'JetBrains Mono',
  'Noto Sans',
  'Noto Serif',
  'Playfair Display',
  'Poppins',
  'Rubik',
  'Source Code Pro',
  'Source Sans Pro',
  'Source Serif Pro',
  'Ubuntu',
  'Barlow',
  'Barlow Condensed',
  'Barlow Semi Condensed',
  'Fira Code',
  'Fira Mono',
  'Fira Sans',
  'Fira Sans Condensed',
  'Fira Sans Extra Condensed',
  'Quicksand',
  'Advent Pro',
  'Bitter',
  'Changa',
  'Changa One',
  'Exo',
  'Exo 2',
  'Great Vibes',
  'Inconsolata',
  'Kaushan Script',
  'Nova Cut',
  'Nova Flat',
  'Nova Mono',
  'Nova Oval',
  'Nova Round',
  'Nova Script',
  'Nova Slim',
  'Nova Square',
  'Oswald',
  'Oxygen',
  'Oxygen Mono',
  'Sacramento',
  'ABeeZee',
  'Abril Fatface',
  'Aldrich',
  'Balsamiq Sans',
  'Bebas Neue',
  'Berkshire Swash',
  'Bilbo',
  'Carter One',
  'Castoro',
  'Cinzel',
  'Federo',
  'Italianno',
  'Josefin Sans',
  'Josefin Slab',
  'Limelight',
  'Oregano',
  'Padauk',
  'Pattaya',
  'Prata',
  'Vollkorn SC',
  'Yesteryear',
  'Abel',
  'Aladin',
  'B612',
  'B612 Mono',
  'Black Han Sans',
  'Bungee',
  'Bungee Hairline',
  'Bungee Inline',
  'Bungee Outline',
  'Bungee Shade',
  'Delius',
  'Delius Swash Caps',
  'Delius Unicase',
  'Julee',
  'Mako',
  'Oleo Script',
  'Oleo Script Swash Caps',
  'Space Grotesk',
  'Space Mono',
  'Spartan',
  'Ubuntu Condensed',
  'Ubuntu Mono',
  'Vollkorn',
  'Work Sans',
  'Zeyada',
  'Zhi Mang Xing',
  'Zilla Slab',
];

export const initialValues = {
  selectFont: '',
};

export const getFontsOptions = (googleFonts) => {
  const googlefontsOptions = googleFonts
    .filter((f) => SUPPORTED_GOOGLE_FONTS.includes(f.family))
    .map((f) => ({
      label: f.family,
      value: f,
    }));
  return googlefontsOptions;
};
export const transformData = (data) => {
  const { family, selectedFiles, type } = data;

  const variants = {};
  selectedFiles.forEach((file) => {
    const key = Object.keys(file)[0];
    if (!variants[key]) {
      variants[key] = file[key];
    }
  });

  const customFontsData = {
    family,
    type,
    variants,
  };

  return customFontsData;
};
export const loadFontStyle = (fontFamily) => {
  const fontLink = document.createElement('link');
  fontLink.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(
    /\s+/g,
    '+',
  )}&display=swap`;
  fontLink.rel = 'stylesheet';
  document.head.appendChild(fontLink);

  return { fontFamily, textDecoration: 'none', color: 'inherit' };
};

export const getFontWeight = (variant) => {
  if (variant.toLowerCase().includes('regular')) {
    return '400';
  }
  const weightMatch = variant.match(/\d+/);
  return weightMatch ? weightMatch[0] : 'normal';
};

export const getFontStyle = (variant) => {
  const styleVariant = variant.replace(/\d+/g, '').trim().toLowerCase();
  const validStyles = ['italic', 'oblique'];
  return validStyles.includes(styleVariant) ? styleVariant : 'normal';
};

export const getUniqueUsers = (items) => {
  const uniqueUsersMap = new Map();
  items.forEach((user) => {
    if (!uniqueUsersMap.has(user.userName)) {
      uniqueUsersMap.set(user.userName, user);
    }
  });
  return Array.from(uniqueUsersMap.values());
};
